
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 41"}},[_c('path',{attrs:{"d":"M57.47 38.6a2 2 0 00-2 2v6.83a6.07 6.07 0 01-6.07 6.07H14.6a6.07 6.07 0 01-6.07-6.07V40.6a2 2 0 10-4 0v6.83A10.08 10.08 0 0014.6 57.5h34.8a10.08 10.08 0 0010.07-10.07V40.6a2 2 0 00-2-2z","fill":"#fff","data-original":"#000000"}}),_c('path',{attrs:{"d":"M30.58 44.44a2 2 0 002.84 0L44.8 33.06a2 2 0 00-2.8-2.83l-8 8V8.5a2 2 0 00-4 0v29.7l-8-8a2 2 0 00-2.83 2.83z","fill":"#fff","data-original":"#000000"}})])])
          )
        }
      }
    